import { compose, withState, withProps, lifecycle } from 'recompose'
import upperFirst from 'lodash/upperFirst'
import isFunction from 'lodash/isFunction'
import withCreateResource from 'hocs/bases/withCreateResource'
import withStateChanged from 'hocs/bases/withStateChanged'
import CmsApis from 'apis/cmsApis';
import { routesByValue } from 'helpers/routesConstant'

/**
 * output props
 *    {resourceName}
 *    onChange
 *    createResource
 *    createResourceStatus
 *    isStateChanged
 *    setIsStateChanged
 *    onDiscardChange
 */

const withCreatePage = ({
  resourceName,
  initialState,
  getAction,
  getOnChange,
  getOnInitialize = () => () => {},
}) => {
  const ResourceName = upperFirst(resourceName)
  return compose(
    withStateChanged(),
    withState(resourceName, 'setResource', initialState),
    lifecycle({
      componentDidMount() {
        this.props.setTempState(this.props[resourceName])
        getOnInitialize(this.props)()
      },
    }),
    withCreateResource({
      resourceName,
      getAction: getAction || (() => CmsApis[`create${ResourceName}`]),
      getOnSuccess: (props) => () => {
        const { router } = props
        if(router){
          router.push(routesByValue[`create${ResourceName}`].redirect)
        }
      }
    }),
    withProps((props) => {
      return {
        onChange: getOnChange ? getOnChange(props) : props.setResource,
        onDiscardChange: () => props.setResource(props.tempState),
        onSave: (data) => props[`create${ResourceName}`](
          data && !isFunction(data) ?
            data
            :
            props[resourceName]
        ),
        saveStatus: props[`create${ResourceName}Status`]
      }
    })
  )
}

export default withCreatePage


// WEBPACK FOOTER //
// ./src/hocs/extends/withCreatePage.js